<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>频道列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="box-card">
            <el-form ref="form" :model="searchForm" label-width="80px" :inline="true" size="small" class="admin_from">

                <el-form-item :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                    <el-input v-model="searchForm.title" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                    <el-select v-model="searchForm.type" placeholder="请选择样式" clearable
                               :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                        <el-option label="猜你喜欢" value="0"></el-option>
                        <el-option label="轮播图" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                    <el-select v-model="searchForm.status" placeholder="请选择状态" clearable
                               :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                        <el-option label="禁用" value="0"></el-option>
                        <el-option label="启用" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                    <el-button type="primary" size="small" @click="addRecharge">添加频道</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    size="small"
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="list_order"
                        label="排序">
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="标题">
                </el-table-column>

                <el-table-column
                        prop="list_order"
                        label="样式">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==0">猜你喜欢</span>
                        <span v-if="scope.row.type==1">轮播图</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="list_order"
                        label="状态">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" active-value="1" inactive-value="0"
                                   @change="chooseSwitch(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                        width="340"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="small" @click="editBanner(scope.row.id)">轮播图管理
                        </el-button>
                        <el-button type="primary" plain size="small" @click="editColumn(scope.row.id)">栏目管理</el-button>
                        <el-button type="warning" plain size="small" @click="edit(scope.row.id)">修改</el-button>
                        <el-button type="danger" plain size="small" @click="remove(scope.row.id)">删除</el-button>
                    </template>

                </el-table-column>
            </el-table>
            <div class="el-pagination">
                <el-pagination
                        background
                        @size-change="changeSize"
                        @current-change="changeCurrent"
                        :current-page="params.pagenum"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="params.pagesize"
                        :total="params.totals"
                        :layout="this.$store.state.paginationLayout">
                </el-pagination>
            </div>
            <el-dialog :title="fromTitle" :width="this.$store.state.dialogWidth" :visible.sync="visible">
                <el-row :gutter="20">
                    <el-col :span="this.$store.state.elColNum">
                        <el-form ref="form" :label-width="this.$store.state.labelWidth" size="small">
                            <el-form-item label="排序">
                                <el-input v-model="form.list_order"></el-input>
                            </el-form-item>
                            <el-form-item label="名称">
                                <el-input v-model="form.title" maxlength="100"></el-input>
                            </el-form-item>
                            <el-form-item label="轮播样式">
                                <el-select v-model="form.type" placeholder="选择轮播样式">
                                    <el-option label="猜你喜欢" value="0"></el-option>
                                    <el-option label="轮播图" value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="状态">
                                <el-select v-model="form.status" placeholder="状态">
                                    <el-option label="启用" value="1"></el-option>
                                    <el-option label="禁用" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false" size="small">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
    import {isRealNum} from '../../../utils/common'

    export default {
        name: "Comic_Release",
        data() {
            return {
                value: false,
                params: {
                    pagenum: 1,
                    pagesize: 10,
                    totals: 0
                },
                tableData: [],
                form: {
                    title: '',
                    list_order: '',
                    type: '',
                    status: '',
                },
                fromTitle: '新增',
                visible: false,
                id: '',
                searchForm: {
                    title: '',
                    type: '',
                    status: '',
                }
            }
        },
        created() {
            this.getList()
        },
        methods: {
            chooseSwitch(e) {
                this.$axios.put('admin/channel/' + e.id, {
                    status: e.status
                }).then((res) => {
                    this.$message.success('成功');
                    this.getList();
                    this.visible = false;
                });
            },
            addRecharge() {
                this.fromTitle = '新增';
                this.id = '';
                this.form = {
                    title: '',
                    list_order: '',
                    type: '',
                    status: '',
                };
                this.visible = true;
            },
            // 每页显示多少条
            changeSize(val) {
                this.params.pagesize = val;
                this.getList();
            },
            // 当前显示的页数
            changeCurrent(val) {
                this.params.pagenum = val;
                this.getList()
            },
            getList() {
                let data = {
                    page: this.params.pagenum,
                    page_size: this.params.pagesize,
                    title: this.searchForm.title,
                    type: this.searchForm.type,
                    status: this.searchForm.status,
                };
                this.$axios.post("admin/channel/index", data).then((res) => {
                    this.params.totals = parseInt(res.data.count);
                    this.tableData = res.data.list;
                });
            },
            // 编辑用户
            edit(id) {
                this.id = id;
                this.fromTitle = '编辑';
                this.$axios.get('admin/channel/' + id, {}).then((res) => {
                    let data = res.data;
                    for (let key in data) {
                        if (isRealNum(data[key])) {
                            data[key] = data[key].toString()
                        }
                    }
                    this.form = data;
                    this.visible = true;
                });
            },
            // 确认提交添加或编辑用户
            dialogAffirm() {
                if (this.id) {
                    this.$axios.put('admin/channel/' + this.id, this.form).then((res) => {
                        this.$message.success('成功');
                        this.getList();
                        this.visible = false;
                    });
                } else {
                    // 添加
                    this.$axios.post('/admin/channel', this.form).then((res) => {
                        this.$message.success('成功');
                        this.getList();
                        this.visible = false;
                    });
                }
            },
            remove(id) {
                this.$confirm('确定要进行操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.del('admin/channel/' + id, '').then((res) => {
                        this.$message.success('删除成功!');
                        this.getList();
                    });
                }).catch(() => {

                });
            },
            editBanner(id) {
                this.$router.push({
                    path: '/novel_channelBanner',
                    query: {
                        channel_id: id
                    }
                })
            },
            editColumn(id) {
                this.$router.push({
                    path: '/novel_channelColumn',
                    query: {
                        channel_id: id
                    }
                })
            },
            search() {
                this.params.pagenum = 1;
                this.getList();
            }
        }
    }
</script>

<style scoped>

</style>